import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "preferences-dialog"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SystemInfo = _resolveComponent("SystemInfo");

  var _component_UserInfo = _resolveComponent("UserInfo");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("h2", null, _toDisplayString(_ctx.$t("preferences.title")), 1)];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_SystemInfo, {
        class: "mb-6"
      }), _createVNode(_component_UserInfo)];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}